const maxYear = new Date().getFullYear();
const minYear = maxYear - 5;
export const isDateValidForOrderSearch = (date: Date) => date.getFullYear() >= minYear && date.getFullYear() <= maxYear;
